<div class="preview" [class.a3]="card_format === AFormat.A3_FORMAT">
  <span class="preview-number">{{index + 1}}.</span>
  <ng-katex *ngIf="isKatexFormat(exercise)" class="katex" [equation]="exercise.text"></ng-katex>
  <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" class="preview-text" [paragraph]="exercise?.text | exerciseFormat" [outerHTML]="exercise?.text"></ng-katex-paragraph>
</div>

